import type { SVGProps } from 'react'

const Monitor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2.5" y="3.333" width="15" height="10" rx="1.667" />
    <path d="M6.667 17.5h6.666M10 13.333V17.5" />
  </svg>
)

export default Monitor
